<script setup lang="ts">
import Select from '@common/src/volt/Select.vue'
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

const languageOptions = [
  { label: 'Français', value: 'fr' },
  { label: 'English', value: 'en' },
]

// Persist language selection and update document language
watch(locale, (newLocale) => {
  localStorage.setItem('user-locale', newLocale)
  document.documentElement.lang = newLocale
}, { immediate: true })
</script>

<template>
  <Select size="small" v-model="locale" :options="languageOptions" optionLabel="label" optionValue="value"
    class="w-32" />
</template>
